import {Link} from 'react-router-dom'

const PaymentSetup = ({location})=>{
	const params = new URLSearchParams(location.search)
	const status = params.get('status')

	return (
		<div>
			{status==='success'?
				<>
					<h1>Sign Up Successful!</h1>
					<p>
						You are ready to get paid by your clients now!
						<Link className="ml-1" to="/financials_dashboard">Go to the Financials page to continue</Link>
					</p>
					<strong className="text-danger d-block">DO NOT use your browser's back button - this can cause issues with the payment setup.</strong>
				</>
				:
				<div>
					Error: Please go <Link to="/financials_dashboard">Back to the Financials page</Link> and try again.  If this issue continues, please contact support@fitsw.com for support.
				</div>
			}
		</div>
	)
}

export default PaymentSetup